module.exports = __webpack_public_path__ + "static/media/ball-btc.8723c44d.svg";